import { getEnvironment } from '../utils/misc'
import type { Environment } from './Environment'

export const ENV: Environment = getEnvironment()
